const getAIConnectSegments = (hotels, level = "HOTEL") => {
    if (hotels?.length >= 1) {
        return [level === "HOTEL" ? 'HOTELS' : 'GROUPS'];
    }
    return [];
};

export default getAIConnectSegments;